/* eslint-disable max-len */
import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "@teamprevent/common/healthSurveillance";

import * as questionIds from "./questionIds";

const medicalTypes = [
    MedicalTypeIds.SkinFaceToFace,
    MedicalTypeIds.SafetyCriticalWorker,
    MedicalTypeIds.WorkAtHeight,
    MedicalTypeIds.WorkingConfinedSpaces,
    MedicalTypeIds.WearingRPE,
    MedicalTypeIds.WearingBreathingApparatus,
    MedicalTypeIds.WorkingThermalEnvironment,
    MedicalTypeIds.Offshore,
    MedicalTypeIds.Airside,
    MedicalTypeIds.OtherFitnessToWork,
    MedicalTypeIds.LAAWorker,
    MedicalTypeIds.SkinFaceToFaceLevel1,
    MedicalTypeIds.SkinAssessmentLevel2
];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../consultation";` which is in a data structure suitable for use with custom medicals
 */
export const skinQuestions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.SkinAssessmentRequired,
        questionText: "Following review of the skin questionnaire",
        medicalTypes
    },
    {
        id: questionIds.AreasOfSkinExamined,
        questionText: "Please mark on the body Image below all areas of the Skin that were examined",
        medicalTypes
    },
    {
        id: questionIds.SkinInGoodCondition,
        questionText: "Was the skin in good condition nothing abnormal detected  ",
        medicalTypes
    },
    {
        id: questionIds.SkinCareAdviceProvided,
        questionText: "Was skin care advice provided",
        medicalTypes
    },
    {
        id: questionIds.GlovesUseAdviceProvided,
        questionText: "Was advice given on the importance of using Gloves use advice provided",
        medicalTypes
    },
    {
        id: questionIds.RightHandColour,
        questionText: "Right Hand Colour",
        medicalTypes
    },
    {
        id: questionIds.RightHandConditionOfSkin,
        questionText: "Right Hand Condition of skin",
        medicalTypes
    },
    {
        id: questionIds.RightHandLesionsPresent,
        questionText: "Right Hand Lesions Present",
        medicalTypes
    },
    {
        id: questionIds.LeftHandColour,
        questionText: "Left Hand Colour",
        medicalTypes
    },
    {
        id: questionIds.LeftHandConditionOfSkin,
        questionText: "Left Hand Condition of skin",
        medicalTypes
    },
    {
        id: questionIds.LeftHandLesionsPresent,
        questionText: "Left Hand Lesions Present",
        medicalTypes
    },
    {
        id: questionIds.HistoryOfContactWithChemicals,
        questionText: "Contact with chemicals (length and duration of exposure)",
        medicalTypes
    },
    {
        id: questionIds.HistoryOfContactWithOtherSubstances,
        questionText: "Contact with other substances (dusts, plants, perfumes, etc)",
        medicalTypes
    },
    {
        id: questionIds.HistoryOfPreviousAllergy,
        questionText: "History of previous allergy, asthma, eczema, hayfever, psoriasis",
        medicalTypes
    },
    {
        id: questionIds.TakingMedicationRegularlyAtPresent,
        questionText: "At present are you taking any medication regularly either prescribed by your GP or bought over the counter?",
        medicalTypes
    },
    {
        id: questionIds.WorkingEnvironmentCateringCleaning,
        questionText: "Working environment (catering, cleaning) ",
        medicalTypes
    },
    {
        id: questionIds.WhetherConditionImprovesAwayFromWork,
        questionText: "Whether the condition improves away from work?",
        medicalTypes
    },
    {
        id: questionIds.FamilyHistoryOfAsthma,
        questionText: "Asthma",
        medicalTypes
    },
    {
        id: questionIds.FamilyHistoryOfHayFever,
        questionText: "Hay fever",
        medicalTypes
    },
    {
        id: questionIds.FamilyHistoryOfEczema,
        questionText: "Eczema",
        medicalTypes
    },
    {
        id: questionIds.FamilyHistoryOfAnySkinCondition,
        questionText: "Any skin condition",
        medicalTypes
    },
    {
        id: questionIds.HomeEnvironment,
        questionText: "Home environment? (hobbies, DIY, pets): 	",
        medicalTypes
    },
    {
        id: questionIds.KnownSkinCondition,
        questionText: "Do you have any known skin condition?",
        medicalTypes
    },
    {
        id: questionIds.SkinConditionName,
        questionText: "What is the skin condition called?",
        medicalTypes
    },
    {
        id: questionIds.HowLongHadSkinCondition,
        questionText: "How long have you had the condition?",
        medicalTypes
    },
    {
        id: questionIds.WhoDiagnosedSkinCondition,
        questionText: "Who diagnosed the condition?",
        medicalTypes
    },
    {
        id: questionIds.TakeMedicationForSkinCondition,
        questionText: "Do you take any medication for this condition even if only occasionally?",
        medicalTypes
    },
    {
        id: questionIds.PartOfBodyAffectedBySkinCondition,
        questionText: "Which part of your body is affected by the skin condition?",
        medicalTypes
    },
    {
        id: questionIds.SkinConditionDryness,
        questionText: "Dryness",
        medicalTypes
    },
    {
        id: questionIds.SkinConditionItching,
        questionText: "Itching",
        medicalTypes
    },
    {
        id: questionIds.SkinConditionRedness,
        questionText: "Redness",
        medicalTypes
    },
    {
        id: questionIds.SkinConditionScaling,
        questionText: "Scaling",
        medicalTypes
    },
    {
        id: questionIds.SkinConditionCracking,
        questionText: "Cracking",
        medicalTypes
    },
    {
        id: questionIds.SkinConditionFlaking,
        questionText: "Flaking",
        medicalTypes
    },
    {
        id: questionIds.SkinConditionBlisters,
        questionText: "Blisters",
        medicalTypes
    },
    {
        id: questionIds.SkinConditionHowLongLast,
        questionText: "How long does it generally last?",
        medicalTypes
    },
    {
        id: questionIds.LastIssueWithSkinCondition,
        questionText: "When did you last experience an issue with your skin due to this condition? ",
        medicalTypes
    },
    {
        id: questionIds.NonMedicationImprovementOnSkinCondition,
        questionText: "Can anything apart from medication bring about an improvement in the skin condition at the time the skin condition is present?",
        medicalTypes
    },
    {
        id: questionIds.AnyCauseDeteriorationToSkinCondition,
        questionText: "Does anything cause deterioration in the skin condition at the time the skin condition is present?",
        medicalTypes
    },
    {
        id: questionIds.HistorySwellingOfFaceHands,
        questionText: "Swelling of face and/or hands",
        medicalTypes
    },
    {
        id: questionIds.HistoryRednessOfFaceHands,
        questionText: "Redness of face and/or hands",
        medicalTypes
    },
    {
        id: questionIds.HistorySneezingRunnyEyes,
        questionText: "Sneezing, runny eyes",
        medicalTypes
    },
    {
        id: questionIds.HistoryCoughShortnessOfBreath,
        questionText: "Cough, shortness of breath",
        medicalTypes
    },
    {
        id: questionIds.HistoryLatexAllergyConfirmed,
        questionText: "Latex allergy/confirmed(?)",
        medicalTypes
    },
    {
        id: questionIds.HistorySkinConditionDetails,
        questionText: "Details and Findings",
        medicalTypes
    }
];
/* eslint-enable max-len */
